import React, { useState, useEffect } from "react";
import { useFormik, Field } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import iconTrash from "src/Assets/iconography/trashwhite.svg";

//Services
import { getUserId } from "../../Api/services/storageService";

function DeleteModal(props) {
  const {
        title,
        subTitle,
        icon,
        cancelTitle,
        actionCancel,
        acceptTitle,
        actionAccept,
        open,
        setOpen
    } = props;


  return (
    <Dialog
      onClose={()=>{
        setOpen(false);
      }}
      open={open}
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogContent
        className='bg-blue'
      >
        <div className="my-4 w-full text-center">
            <div>
                <img
                    src={icon ? icon : iconTrash}
                    alt=""
                    className="w-12 h-auto ml-auto mr-auto mb-4"
                />
            </div>
            
            <p className="text-xl text-bold text-white">
                { title }
            </p>
            <p className="text-xl text-light text-white my-2">
                { subTitle }
            </p>
            <div className="flex justify-center my-6 w-full">
                <button
                    onClick={()=>{
                      setOpen(false);
                      if(actionCancel)
                        actionCancel()
                    }}
                    className="text-base text-bold text-white hover:bg-hover py-2 px-6 rounded-lg border border-white mx-2"
                >
                    { cancelTitle}
                </button>
                <button
                    onClick={actionAccept}
                    className="text-base text-bold text-blue bg-white hover:bg-hover py-2 px-6 rounded-lg mx-2"
                >
                    { acceptTitle }
                </button>
            </div>
        </div>
      </DialogContent>

    </Dialog>
  );
}

export default DeleteModal;
